// extracted by mini-css-extract-plugin
module.exports = {"sizeGuideCell":"SizeGuideCell_sizeGuideCell__Vvmx0","description":"SizeGuideCell_description__MBbQs"};